import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { sharedProductNameStyles } from '../../styles';
import PriceNotice from '../price-notice';
import StockStatusColumnComponent from '../stock-status-column';

export const StockStatus = styled.div`
  color: ${p => p.theme.text.quaternary};
  font-size: 0.8rem;
  margin: 0 0.2em;
`;

export const ProductName = styled.div`
  ${sharedProductNameStyles};
`;

export const StockStatusColumn = styled(StockStatusColumnComponent)`
  display: flex;
`;

export const PriceAndStockWrapper = styled.div`
  ${media.smallOnly`
    display: grid;
    grid-template-columns: 40px 1fr;
    align-items: baseline;
  `}

  ${media.mediumUp`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  `}
`;

export const PriceNoticeLabel = styled(PriceNotice)`
  font-size: ${layout.fontSizes.small.mobile.rem};
  white-space: nowrap;
  font-style: italic;
  margin-bottom: 2px;
`;

export const StockStatusColumnWrapper = styled.div``;

export const PriceColumnWrapperExperiment = styled.div`
  display: flex;
  width: auto;
  height: auto;
  flex-direction: column;
  align-items: flex-end;
`;
